import { ComponentStyleConfig } from '@chakra-ui/react';
import tema from './tema';

const ButtonStyles: ComponentStyleConfig = {
  baseStyle: {
    borderRadius: 'full',
    display: 'flex',
    alignItems: 'center',
    gap: '0.40rem',
    lineHeight: '100%',
  },
  defaultProps: {
    colorScheme: 'bGreen',
  },
  variants: {
    solid: ({ colorScheme }) => ({
      _disabled: {
        pointerEvents: 'none',
      },
      _hover: {
        transitionTimingFunction: 'ease-out',
        backgroundColor: `${colorScheme}.500`,
        boxShadow: `0px 2px 0.5em var(--chakra-colors-${colorScheme}-300)`,
      },
    }),
    action: (props) => ({
      ...tema.components.Button.variants.solid(props),
      bg: 'bOrange.500',
      justifyContent: 'space-between',
      paddingInline: '1rem',
      fontSize: 'md',

      _hover: {
        _disabled: {
          bg: 'compo.800',
          color: 'compo.50',
          boxShadow: 'none !important',
          transform: 'none',
        },

        transform: 'translateY(-1.5px)',
        shadow: 'lg',
      },

      _disabled: {
        bg: 'compo.800',
        color: 'compo.50',
      },

      _active: {
        bg: '#000000',
      },

      _loading: {
        justifyContent: 'center',
        alignItems: 'center',
      },
    }),
    icon: {
      color: 'compo.300',
      cursor: 'pointer',
      _hover: {
        color: 'foreground',
      },
    },
    mailLink: ({ colorScheme }) => ({
      bg: '#FFFFFF',
      borderWidth: '2px',
      borderColor: colorScheme,
      color: colorScheme,
      borderRadius: 'md',
      py: 1,
      px: 3,
      _hover: {
        boxShadow: `0px 1px 8px 0px ${colorScheme}80, 0px 0px 4px 0px ${colorScheme}40;`,
      },
    }),
  },
};

export default ButtonStyles;
